module.exports = __webpack_public_path__ + "img/sel_Dalian.8c0dc5d7.jpg";